module.exports = __webpack_public_path__ + "img/equipment_base_station.fbc80483.svg";